import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IIncidents } from 'src/app/models/incident';
import { ComplaintsTickets } from 'src/app/models/tickets';

@Component({
  selector: 'app-lodged-complaints-card',
  templateUrl: './lodged-complaints-card.component.html',
  styleUrls: ['./lodged-complaints-card.component.scss'],
})
export class LodgedComplaintsCardComponent {
  @Input() set complaintsData(val: ComplaintsTickets[]) {
    this.complaintList = val;
  }
  @Input() set complaintsType(val: string) {
    this.labelName = val;
  }

  @Output() showDetails = new EventEmitter<any>();
  @Output() snoozeIncident = new EventEmitter<any>();
  labelName: string = null;
  complaintList: ComplaintsTickets[] = [];
  onShowDetails(val: any) {
    this.showDetails.emit(val);
  }
  onsnoozeIncident(val: IIncidents) {
    this.snoozeIncident.emit(val);
  }
  getFormatedDate(val: any) {
    const date = new Date(val + 'Z'); // Convert UTC to local tim
    return date;
  }
}
